(function () {
  'use strict';

  function moveToReviews(event) {
    if (!(event.target instanceof Element)) return;

    var badge = event.target.closest('.product .jdgm-preview-badge--with-link');
    if (!badge || badge.classList.contains('otf-card-rating')) return;

    var reviews = document.getElementById('judgeme_product_reviews');
    if (!reviews || reviews.hidden || reviews.getClientRects().length === 0) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    reviews.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  document.addEventListener('click', moveToReviews, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') moveToReviews(event);
  }, true);
})();
